import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Tab from '@components/common/tab';

import { useApplicationStatus } from '@repository/match';
import ApplyList from './applyList';
import {
  MatchingApplicationStatusEnum,
  MatchingApplicationStatusType,
} from '@domain/rs/match/MatchingHomeApplicationPositionRs';
import useMessageModal from '@utils/hooks/useMessageModal';
import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface TitleProps {
  title: string;
  count: number;
  isNew?: boolean;
}

const Title = ({ title, count, isNew }: TitleProps) => {
  return (
    <div className={cx('titleContainer')}>
      <div className={cx('count', { isNew })}>{count}</div>
      <div className={cx('title')}>{title}</div>
    </div>
  );
};

interface Props {
  tabType: MatchingApplicationStatusType;
  setTabType: (tabType: MatchingApplicationStatusType) => void;
}
const ApplyTab = ({ tabType, setTabType }: Props) => {
  const { query } = useRouter();
  const { data } = useApplicationStatus();
  const { openMessageModal } = useMessageModal();

  useEffect(() => {
    if (query.sn) openMessageModal(Number(query.sn));
    if (query.tab) {
      setTabType(query.tab as MatchingApplicationStatusType);
      UrlUtil.removeQueryStringAndReplace('tab');
    }
  }, [query]);

  return (
    <Tab
      className={cx('container')}
      active={tabType}
      onTabChange={(tab) => setTabType(tab as MatchingApplicationStatusType)}
    >
      <Tab.Item
        title={<Title title="전체" count={data?.totalCount ?? 0} isNew={false} />}
        index={MatchingApplicationStatusEnum.ALL}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <ApplyList tabType={MatchingApplicationStatusEnum.ALL} />
      </Tab.Item>
      <Tab.Item
        title={<Title title="지원 완료" count={data?.applicationCompleteCount ?? 0} isNew={false} />}
        index={MatchingApplicationStatusEnum.APPLICATION}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <ApplyList tabType={MatchingApplicationStatusEnum.APPLICATION} />
      </Tab.Item>
      <Tab.Item
        title={<Title title="전형 진행 중" count={data?.inProgressCount ?? 0} isNew={false} />}
        index={MatchingApplicationStatusEnum.IN_PROGRESS}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <ApplyList tabType={MatchingApplicationStatusEnum.IN_PROGRESS} />
      </Tab.Item>
      <Tab.Item
        title={<Title title="전형 종료" count={data?.processEndCount ?? 0} isNew={false} />}
        index={MatchingApplicationStatusEnum.END}
        className={cx('item')}
        activeClassName={cx('active')}
        nonActiveClassName={cx('nonActive')}
      >
        <ApplyList tabType={MatchingApplicationStatusEnum.END} />
      </Tab.Item>
    </Tab>
  );
};

export default ApplyTab;
